//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/Select/Select.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Video from "@material-ui/icons/VideoCall";
import Photos from "@material-ui/icons/PhotoCameraOutlined";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

import ReactPlayer from 'react-player'

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
    return <Slide direction="down" {...props} />;
}
  
  class VideoEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        video: { 
          Name: "",
          Description: "",
          Type: "Insight",
          URL:"",
          Quarter: 1,
          Week: 1,
          Day: 1,
          GradeLevel: "0-1",
          Photos: [] 
        }
      };

      this.saveVideo = this.saveVideo.bind(this);
      this.updateVideo = this.updateVideo.bind(this);

      this.deletePhoto = this.deletePhoto.bind(this);
      this.updatePhoto = this.updatePhoto.bind(this);
      this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
      this.makeThumbPhoto = this.makeThumbPhoto.bind(this);
    }

    handleClickOpen(modal) {

      var video = this.props.video;

      if(!video.Quarter)
        video.Quarter = 1;

      if(!video.Week)
        video.Week = 1;

      if(!video.Day)
        video.Day = 0;
      
      if(!video.GradeLevel)
        video.GradeLevel = "0-1";

      if(!video.Type)
        video.Type = "Insight";

      this.setState({video: video});

      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateVideo(property, value) {
      var video = this.state.video;
      video[property] = value;
      this.setState({video: video});
    }

    addPhoto(url) {

      var video = this.state.video;
      if(!video.Photos) {
        video.Photos = [];
      }

      var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

      video.Photos.push(photo);
      this.setState({video:video});
    }

    updatePhoto(photo) {
      var video = this.state.video;
      
      for(var i = 0; i < video.Photos.length; i++) {
        if(video.Photos[i].ID === photo.ID) {
          video.Photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var video = this.state.video;

      for(var i = video.Photos.length - 1; i > -1; i--) {
        if(video.Photos[i].ID === photo.ID) {
          video.Photos.splice(i,1);
          break;
        }
      }

      this.setState({video:video});
    }

    makeCoverPhoto(photo) {
      var video = this.state.video;
      
      for(var i = 0; i < video.Photos.length; i++) {
        if(video.Photos[i].ID === photo.ID) {
          video.Photos[i].isCover = true;
        } else {
          video.Photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var video = this.state.video;
      
      for(var i = 0; i < video.Photos.length; i++) {
        if(video.Photos[i].ID === photo.ID) {
          video.Photos[i].isThumb = true;
        } else {
          video.Photos[i].isThumb = false;
        }
      }
    }

    saveVideo() {

      var video = this.state.video;

      if(video.Type === 'Insight')
        delete video.Day;
      else if (video.Type === 'Announcement')
        delete video.GradeLevel;
    
      db.updateVideo(video.id, video).then(doc => {
        
        if(!video.id) { // i.e. if it's a new video

          video.id = doc.id;
          
          this.props.onNew(this.state.video);

          ReactGA.event({
            category: 'Video',
            action: 'Created a New Video'
          });

          // reset to blank
          this.setState({video:{
            Name: "",
            Description: "",
            URL:"",
            Photos: [],
            Quarter:1,
            Week:1,
            GradeLevel:"0-1",
            Type: "Insight",
            orgId: this.props.org.id
          }});

        } else { // i.e. an existing video

          this.props.onChange(this.state.video);

          ReactGA.event({
            category: 'Video',
            action: 'Updated a Video'
          });
        }
      });
    }
        
    // photos
    photoUploadStart = () => this.setState({isUploading: true, progress: 0});
    photoUploadProgress = (progress) => this.setState({progress});
    photoUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    photoUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
    };


    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    showGradeLevel() {
      if(this.state.video.Type === 'Insight')
        return "block";
      else
        return "none";
    }

    showDay() {
      if(this.state.video.Type === 'Announcement')
        return "block";
      else
        return "none";
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            maxWidth="md"
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Video</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Video,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              id="Name"
                              labelText="Name"
                              value={this.state.video.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateVideo("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomSelect
                                labelText="Type"
                                value={this.state.video.Type}
                                inputProps={{
                                    placeholder: "Type"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateVideo("Type", e.target.value)}
                                options={[ {key:"Announcement", label:"Announcement" }, { key:"Insight", label:"Insight" }, { key:"Other", label:"Other" } ]}
                              />
                          </GridItem>
                          
                          <GridItem xs={12} sm={12} md={3}>
                              <CustomSelect
                                id="quarter"
                                labelText="Quarter"
                                value={this.state.video.Quarter}
                                inputProps={{
                                    placeholder: "Quarter"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateVideo("Quarter", e.target.value)}
                                options={[
                                  {key:1,label:"1"},
                                  {key:2,label:"2"},
                                  {key:3,label:"3"},
                                  {key:4,label:"4"}]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                              <CustomSelect
                                id="week"
                                labelText="Week"
                                value={this.state.video.Week}
                                inputProps={{
                                    placeholder: "Week"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateVideo("Week", e.target.value)}
                                options={[
                                  {key:1,label:"1"},
                                  {key:2,label:"2"},
                                  {key:3,label:"3"},
                                  {key:4,label:"4"},
                                  {key:5,label:"5"},
                                  {key:6,label:"6"},
                                  {key:7,label:"7"},
                                  {key:8,label:"8"},
                                  {key:9,label:"9"}
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3} style={{display:this.showDay()}}>
                              <CustomSelect
                                id="day"
                                labelText="Day"
                                value={this.state.video.Day}
                                inputProps={{
                                    placeholder: "Day"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateVideo("Day", e.target.value)}
                                options={[
                                  {key:1,label:"Monday"},
                                  {key:2,label:"Tuesday"},
                                  {key:3,label:"Wednesday"},
                                  {key:4,label:"Thursday"},
                                  {key:5,label:"Friday"}
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3} style={{display:this.showGradeLevel()}}>
                            <CustomSelect
                                labelText="Grade Level"
                                value={this.state.video.GradeLevel}
                                inputProps={{
                                    placeholder: "Grade Level"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateVideo("GradeLevel", e.target.value)}
                                options={[ { key:"0-1", label:"K-1" }, { key:"2-3", label:"2-3" }, { key:"4-5", label:"4-5" }, { key:"6-8", label:"6-8" }]}
                              />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              id="URL"
                              labelText="URL"
                              value={this.state.video.URL}
                              inputProps={{
                                  placeholder: "URL"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateVideo("URL", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <ReactPlayer url={this.state.video.URL} width='100%' />
                          </GridItem>
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.video.Photos.map(photo => (
                              <PhotoCard key={photo.id} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveVideo();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

VideoEditor = connect(mapStateToProps)(VideoEditor);
export default withStyles(modalStyle)(VideoEditor);


// WEBPACK FOOTER //
// ./src/components/VideoEditor/VideoEditor.jsx